<template lang="pug">
div
  v-text-field(
    label="Amount"
    v-model="formData.value"
    :error="formErrors.hasError('value')"
    :error-messages="formErrors.fields.value"
  )
  v-text-field(
    label="Label"
    v-model="formData.label"
    :error="formErrors.hasError('label')"
    :error-messages="formErrors.fields.label"
  )
  v-text-field(
    label="Subject"
    v-model="formData.subject"
    :error="formErrors.hasError('subject')"
    :error-messages="formErrors.fields.subject"
  )
  v-textarea(
    outlined
    label="Content"
    :rows="12"
    placeholder="Type your text here..."
    v-model="formData.content"
    :error="formErrors.hasError('content')"
    :error-messages="formErrors.fields.content"
  )

</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    formErrors: Object
  },

  data:() => ({
    formData: {
      amount: null,
      label: null,
      subject: null,
      content: null
    }
  }),

  mounted() {
    this.setData()
  },

  methods: {
    setData() {
      if(!this.item) return
      this.formData.value = this.item.value || ''
      this.formData.label = this.item.label || ''
      this.formData.subject = this.item.subject
      this.formData.content = this.item.content
    },

    getData() {
      return this.formData
    }
  }
}
</script>